import { FACEBOOK_ID, FACEBOOK_PAGE_ID } from '@root/config/credentials';
import { privacyPolicyService, PrivacyPolicyStatus } from '@root/src/services/privacy-policy/privacy-policy';
import React, { useEffect } from 'react';

declare module 'react' {
    interface HTMLAttributes<T> extends React.DOMAttributes<T> {
        page_id?: string;
        theme_color?: string;
        greeting_dialog_display?: string;
    }
}

declare global {
    interface Window {
        fbAsyncInit: () => void;
    }
}

const CustomerChat: React.FC = () => {
    useEffect(() => {
        const privacyPolicyStatus = privacyPolicyService.getStatus();
        if (privacyPolicyStatus !== PrivacyPolicyStatus.ACCEPTED) {
            return;
        }
        window.fbAsyncInit = () => {
            FB.init({
                appId: FACEBOOK_ID,
                cookie: true,
                xfbml: true,
                version: 'v7.0',
                autoLogAppEvents: true,
            });
        };
        const jsScript = document.getElementsByTagName('script')[0];
        const script = document.createElement('script');
        script.src = 'https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js';
        script.id = 'facebook-jssdk';
        jsScript.parentNode.insertBefore(script, jsScript);
        return () => {
            delete window.FB;
            jsScript.parentNode.removeChild(script);
        };
    }, []);

    return (
        <div className="customer-chat">
            <div id="fb-root"></div>
            <div
                className="fb-customerchat"
                page_id={FACEBOOK_PAGE_ID}
                theme_color="#9e8d7f"
                greeting_dialog_display="hide"
            ></div>
        </div>
    );
};

export default CustomerChat;
